import React, { FC } from 'react';

type Props = {
  classCss?: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconArrowLast: FC<Props> = ({ classCss, props }) => {
  return (
    <svg viewBox="0 0 24 24" version="1.1" className={classCss} {...props}>
      <g id="last" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M6.45181979,0 L6.491,11.491 L17.5817454,0 L18.6257226,1.08170164 L8.86946003,11.1920403 L8.05041504,12 L8.7872222,12.7227502 L18.6257226,22.9172779 L17.5817454,24 L6.494,12.511 L6.53405762,24 L5,24 L5,0 L6.45181979,0 Z"
          id="Combined-Shape"
          fill="#393D49"
          transform="translate(11.812861, 12.000000) rotate(-180.000000) translate(-11.812861, -12.000000) "
        />
      </g>
    </svg>
  );
};

export default IconArrowLast;
